import ListItemComponent from '../../../stories/molecules/list-items'
import {
  listItemListViewVariantOptions,
  listItemsCheckVariantOptions
} from '../../../stories/molecules/list-items/constants'
import { CopyMembersTabMembersContainer } from '../../styled-components'
import { iconSizeOptions } from '../../../stories/atoms/icons/icons-sizes'
import LoadingComponent from '../../../async-loader/loading-component'
import CopyProjectMembersEmpty from '../copy-project-members-empty'
import { copyProjectMembersTabOptions } from '../../constants'
import { isEmpty } from 'lodash'
import ContactItem from './contact-item'

const checkboxCheckComponent = {
  checkInputType: listItemsCheckVariantOptions.CHECKBOX
}

const ContactsList = ({
  contacts = [],
  isLoading = false,
  searchValue = '',
  selectedItemIds = [],
  onToggleSelect = () => {}
}) => {
  const selectedIdsSet = new Set(selectedItemIds)

  if (isLoading) {
    return <LoadingComponent size={iconSizeOptions['ICON-L']} />
  }

  if (isEmpty(contacts)) {
    return (
      <CopyProjectMembersEmpty
        variant={copyProjectMembersTabOptions.CONTACTS}
        searchValue={searchValue}
      />
    )
  }

  return (
    <ListItemComponent.Root
      listViewType={listItemListViewVariantOptions.TOGETHER}
      checkComponent={checkboxCheckComponent}
      dividerFull={false}
      hideDivider
    >
      <CopyMembersTabMembersContainer>
        {contacts.map((item) => {
          return (
            <ContactItem
              key={item.id}
              item={item}
              isSelected={selectedIdsSet.has(item.id)}
              onToggleSelect={onToggleSelect}
            />
          )
        })}
      </CopyMembersTabMembersContainer>
    </ListItemComponent.Root>
  )
}

export default ContactsList
